export const INNO_AL_RE = [
  require("../assets/innoAlRe/1.JPG"),
  require("../assets/innoAlRe/v1.jpg"),
  require("../assets/innoAlRe/2.JPG"),
  require("../assets/innoAlRe/10.jpg"),
  require("../assets/innoAlRe/7.JPG"),
  require("../assets/innoAlRe/6.JPG"),
  require("../assets/innoAlRe/4.JPG"),
];

export const IL_BARBIERE_DI_SIVIGLIA = [
  require("../assets/barbiere/balcone.jpeg"),
  require("../assets/barbiere/6.JPG"),
  require("../assets/barbiere/2.JPG"),
  require("../assets/barbiere/3.JPG"),
  require("../assets/barbiere/fiori.jpg"),
  require("../assets/barbiere/7.JPG"),
  require("../assets/barbiere/fullb.jpg"),
  // require("../assets/barbiere/6.JPG"),
];

export const LOSTERIA_DI_MARECHIARO = [
  require("../assets/osteria/balconeos.jpg"),
  require("../assets/osteria/9.JPG"),
  require("../assets/osteria/2.JPG"),
  require("../assets/osteria/5.JPG"),

  require("../assets/osteria/3.JPG"),
  require("../assets/osteria/bagno.jpg"),
  // require("../assets/osteria/8.JPG"),
  // aggiungi qui tutte le immagini per LOSTERIA_DI_MARECHIARO
];

export const LA_MOLINARA = [
  require("../assets/molinara/room5.JPG"),
  require("../assets/molinara/porta.png"),
  require("../assets/molinara/room4.JPG"),
  require("../assets/molinara/room7.JPG"),
  require("../assets/molinara/room10.jpg"),
  require("../assets/molinara/room8.JPG"),

  // require("../assets/molinara/room4.JPG"),
  // require("../assets/molinara/room5.JPG"),
  // require("../assets/molinara/room3.JPG"),
  // require("../assets/molinara/room10.jpg"),
];
export const IL_MATRIMONIO_INASPETTATO = [
  // require("../assets/matrimonio/1.JPG"),
  require("../assets/matrimonio/2.JPG"),
  require("../assets/matrimonio/fullroom.png"),
  require("../assets/matrimonio/3.JPG"),
  require("../assets/roomsPage/5W8A1772.jpg"),
  require("../assets/matrimonio/blacone.jpg"),
  // require("../assets/matrimonio/bagno2.png"),
  require("../assets/matrimonio/9.JPG"),
  require("../assets/matrimonio/5.JPG"),

  // aggiungi qui tutte le immagini per IL_MATRIMONIO_INASPETTATO
];

export const CUCINA = [
  require("../assets/1811/1.jpg"),
  require("../assets/1811/2.jpg"),
  require("../assets/1811/3.jpg"),
  require("../assets/1811/4.jpg"),
  require("../assets/1811/5.jpg"),
  require("../assets/1811/6.jpg"),

  // aggiungi qui tutte le immagini per IL_MATRIMONIO_INASPETTATO
];

export const ROOMSPAGE = [
  require("../assets/roomsPage/5W8A1772.jpg"),
  require("../assets/roomsPage/5W8A1842.jpg"),
  // require("../assets/roomsPage/5W8A1818.jpg"),
  require("../assets/roomsPage/5.jpg"),

  require("../assets/1811Mobile/lamp.JPG"),
  require("../assets/1811Mobile/balcone.JPG"),
  require("../assets/resFinal/saune.JPG"),
  // require("../assets/roomsPage/5W8A1842.jpg"),
  // require("../assets/resFinal/vassoio2.png"),
  // require("../assets/resFinal/saune.JPG"),

  // aggiungi qui tutte le immagini per IL_MATRIMONIO_INASPETTATO
];

